"use client";

import { useEffect } from "react";
import { useRouter } from "next/navigation";

export default function ClientRedirect() {
  const router = useRouter();

  useEffect(() => {
    router.replace("/?contact=true");
  }, [router]);

  return (
    <div className="min-h-screen flex text-[#002F6D] items-center justify-center">
      <p>Please wait...</p>
    </div>
  );
}
